import React, { Component } from 'react';
import { connect } from 'react-redux';
import { appActions } from 'state/modules/app';
import { Link } from 'react-router-dom';
import AuthError from 'components/AuthError';
import btnStyles from 'styles/partials/_button.css';
import componentStyles from 'styles/partials/_login.css';

class ResetPassword extends Component {
  constructor(props) {
    super(props);
    this.handleReset = this.handleReset.bind(this);
    this.state = {
      username: props.match.params.username || null,
      password: '',
      password2: '',
    };
    this.styles = Object.assign({}, componentStyles, btnStyles);

    this.usernameRef = React.createRef();
    this.passwordRef = React.createRef();
    this.password2Ref = React.createRef();
    this.submitRef = React.createRef();
  }

  componentDidMount() {
    if (this.state.username != null) {
      this.passwordRef.current.focus();
    } else {
      this.usernameRef.current.focus();
    }
  }

  componentWillReceiveProps(nextProps) {
    const app = nextProps.app;
    if (app.result && app.result.success) {
      this.props.history.push({
        pathname: '/Login',
        state: { previousLocation: this.props.history.location?.pathname || 'back' },
      });
    }
  }

  handleUserChange(event) {
    this.setState({ username: event.target.value });
  }

  handlePasswordChange(event) {
    this.setState({ password: event.target.value });
  }

  handlePassword2Change(event) {
    this.setState({ password2: event.target.value });
  }

  render() {
    const { app } = this.props;
    return (
      <div className={this.styles['container']}>
        {app.authAlert ? (
          <AuthError
            screen="reset"
            errors={app.authAlert.violations?.password}
            message={app.authAlert.message || 'Password reset failed'}
          />
        ) : (
          ''
        )}
        <div className={this.styles['loginDim']} />
        <div className={this.styles['loginSection']}>
          <div className={this.styles['loginLogo']}>
            <img className={this.styles['loginLogoImg']} src="/images/OGL-Profit4Logo.png" alt="OGL Profit4 Logo" />
          </div>
          <div className={this.styles['loginForm']}>
            <form onSubmit={this.handleReset} className={this.styles['formContainer']}>
              <h3 className={this.styles['heading']}>
                <span className={this.styles['headingAlt']}>Reset Password</span>
              </h3>
              {alert}
              <div className={this.styles['inputGroup']}>
                <input
                  type="text"
                  ref={this.usernameRef}
                  onChange={this.handleUserChange.bind(this)}
                  value={this.state.username}
                  className={this.styles['input']}
                  aria-describedby="sizing-addon1"
                  placeholder="Username"
                />
              </div>
              <input
                type="password"
                ref={this.passwordRef}
                onChange={this.handlePasswordChange.bind(this)}
                value={this.state.password}
                className={this.styles['input']}
                aria-describedby="sizing-addon1"
                placeholder="New Password"
              />
              <input
                type="password"
                ref={this.password2Ref}
                onChange={this.handlePassword2Change.bind(this)}
                value={this.state.password2}
                className={this.styles['input']}
                aria-describedby="sizing-addon1"
                placeholder="Repeat New Password"
              />
              <button ref={this.submitRef} type="submit" className={this.styles['loginBtn']}>
                Reset Password
              </button>
              <Link to="/Login" className={this.styles['forgotten']}>
                Return to Login Screen
              </Link>
            </form>
          </div>
        </div>
      </div>
    );
  }

  handleReset(e) {
    e.preventDefault();
    const token = this.props.match.params.token;
    const username = this.state.username;
    const password = this.state.password;
    const password2 = this.state.password2;
    if (password.trim() === password2.trim()) {
      this.props.dispatch(appActions.resetPassword(username, password, token));
    }
    this.submitRef.current.blur();
  }
}

function mapStateToProps(state) {
  return {
    app: state.app,
  };
}

export default connect(mapStateToProps)(ResetPassword);
